<template>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel"><slot></slot></h5>
    <button type="button" v-on:click="clear" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <!-- Modifier Name -->
    <div class="mt-3">
      <label for="modifierName" class="form-label">* Modifier Name</label>
      <input type="text" v-model="modifierName" class="form-control" id="modifierName" placeholder="Enter modifier name">
    </div>

    <!-- Adds to Price Checkbox -->
    <div class="form-check mt-3">
      <input
        type="checkbox"
        class="form-check-input"
        v-model="adjustsPayment"
        id="adjustsPayment"
      />
      <label class="form-check-label" for="addsToPrice">Adds to Price</label>
      <button class="tooltip-btn " type="button" v-on:click="alertInfo()" >
      <span class="question-mark">?</span>
    </button>
    </div>

    <!-- Multi-Selection Checkbox -->
    <div class="form-check mt-3">
      <input
        type="checkbox"
        class="form-check-input"
        v-model="isMultiSelection"
        id="isMultiSelection"
      />
      <label class="form-check-label" for="isMultiSelection">Multi-Selection</label>
    </div>

    <div class="form-check mt-3">
      <input
        type="checkbox"
        class="form-check-input"
        v-model="isRequired"
        id="isRequired"
      />
      <label class="form-check-label" for="isRequired">Is Required</label>
    </div>
    <div class="form-check mt-3">
      <input
        type="checkbox"
        class="form-check-input"
        v-model="isItemSpecific"
        id="isItemSpecific"
      />
      <label class="form-check-label" for="isItemSpecific">Is item Specific</label>
      <select v-if="isItemSpecific" id="dropdown" class="form-select" v-model="selectedItem">
       <option v-for="(item,index2) in itemList" :key="index2" class="card mx-3" :value="item._id">{{item.name}}</option>
    </select>
    </div>

    <!-- Answers Section -->
    <div class="mt-3">
      <label for="answers" class="form-label">*Modifier Answers</label>
      <div v-for="(answer, index) in answer_list" :key="index" class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          v-model="answer.text"
          placeholder="Enter answer text"
        />
        <input v-if="adjustsPayment"
          type="text"
          class="form-control ms-2"
          v-model="answer.cost"
          placeholder="Enter answer text"
        />
        <button
          type="button"
          class="btn btn-danger"
          v-on:click="removeAnswer(index)"
        >
          Remove
        </button>
      </div>
      <button type="button" class="btn btn-outline-primary" v-on:click="addAnswer">
        Add Answer
      </button>
    </div>

    <!-- Save/Cancel Buttons -->
    <div v-if="canSubmit" class="btn-group float-right mt-4" role="group">
      <button
        type="button"
        class="btn btn-success"
        v-on:click="save"
        data-bs-dismiss="modal"
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-secondary mx-3"
        v-on:click="clear"
        data-bs-dismiss="modal"
      >
        Cancel
      </button>
    </div>
    <div v-else class="btn-group float-right mt-4" role="group">
      <div class="tooltip-wrapper">
        <button type="button" class="btn btn-success" disabled>
          Save
        </button>
        <span class="tooltip-text">Please complete form</span>
      </div>
      <button
        type="button"
        class="btn btn-secondary mx-3"
        v-on:click="clear"
        data-bs-dismiss="modal"
      >
        Cancel
      </button>
    </div>

  </div>
</div>
    </div>
</template>

<script>

import swal from 'sweetalert';

export default {
     name: 'AddModifier',
  props:["itemType","editmodifier","venue_id","currentHeaderUpdate","currentItems"],
  data() {
    return{
        isEdit:false,
        modifierName: "",
      adjustsPayment: false,
      isMultiSelection: false,
      isRequired:false,
      isItemSpecific:false,
      selectedItem:"0",
      itemList:[{_id:0,name:"Please select an item"}],
      answer_list: [{
            cost:"0.00",
            text:""
        }],
    }
  },
  mounted(){
   
  },
  watch:{
    editmodifier(){
        if(this.$props.editmodifier != ''){
            this.modifierName= this.$props.editmodifier.name
        this.adjustsPayment=this.$props.editmodifier.adjustsPayment
        this.isMultiSelection = this.$props.editmodifier.isMultiSelection
        this.isRequired = this.$props.editmodifier.isRequired
        this.answer_list=this.$props.editmodifier.answer_list
        this.isEdit=true
        this.isItemSpecific = this.$props.editmodifier.is_item_specific
        this.selectedItem = this.$props.editmodifier.is_item_specific? this.$props.editmodifier.relationship_ID:'0'
        }        
    },
    currentItems(newVal){
       this.itemList = [...this.itemList, ...newVal];
    }
  },
  computed:{
    canSubmit(){
       if(this.isItemSpecific &&  (this.selectedItem === '0'|| !this.selectedItem)){
        return false;
        }
      if(this.modifierName.length<1){
        return false;
      }
      if(this.answer_list.length<1){
        return false
      }
        return true;
    }
  },
  methods:{
    alertInfo(){
      swal("Price additions","Select if you want modifier to add to price of item. Modifiers are not added to tax calculations, adjust price accordingly")
    },
    addAnswer(){
        const newAnswer = {
            cost:"0.00",
            text:""
        }
        this.answer_list.push(newAnswer)
    },
    removeAnswer(index) {
      this.answer_list.splice(index, 1);
    },
    clear(){
        this.modifierName= ""
        this.adjustsPayment=false
        this.isMultiSelection = false
        this.isRequired = false
        this.isItemSpecific = false
        this.itemList = [{_id:0,name:"Please Select a Location"}]
        this.selectedItem = '0'
        this.answer_list=[{
            cost:"0.00",
            text:""
        }]
        this.isEdit=false
        this.$emit("clearEdit")
    },
    async save(){ // might need to clear modal after save
       const newModifier = {
        name: this.modifierName,
        adjustsPayment: this.adjustsPayment,
        isMultiSelection: this.isMultiSelection,
        answer_list: this.answer_list,
        isRequired: this.isRequired,
        is_item_specific: this.isItemSpecific,
        relationship_ID: this.isItemSpecific ? this.selectedItem : this.$props.currentHeaderUpdate._id,
        venue_ID:this.$props.venue_id,
        is_disabled:false,
        item_header_id: this.$props.currentHeaderUpdate._id
      };
        if(!this.isEdit) await this.$emit("addNewModifier",newModifier)
        else {
           await this.$emit("updateModifier",{modifier:newModifier,id:this.$props.editmodifier._id})
        }
        this.clear()
    },
  }
}
</script>
<style>
  .tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-wrapper .tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 8px;
  border-radius: 4px;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
 </style>